import { Settings } from '../app/Settings'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    gtag?: (...args: any[]) => void
  }
}

import { LoggerAnalytics } from '@codeleap/common'
import { getFirebase } from './firebaseApp'
import { QueryKeys } from './api/session/queryKeys'

const enabled = typeof window !== 'undefined' ? Settings.EnableAnalytics : false

export const AppAnalytics = new LoggerAnalytics.Analytics({
  init: async () => {
    if (!enabled) return

    const fb = await getFirebase()
    const analytics = fb.analytics()
    analytics.setAnalyticsCollectionEnabled(true)
    analytics.logEvent('page_view', {})

  },
  onEvent: async (eventArgs) => {
    if (!enabled) return

    const fb = await getFirebase()
    const analytics = fb.analytics()
    analytics.logEvent(eventArgs.name, eventArgs)

    if (eventArgs.data?.conversion) {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', eventArgs.name, eventArgs.data)
      }
    }

  },
  prepareData: () => {
    if (!enabled) return {}

    const extraData = { user: QueryKeys.me.getData() }
    return extraData
  },
  onInteraction: async (eventArgs) => {
    if (!enabled) return

    const fb = await getFirebase()
    const analytics = fb.analytics()
    analytics.logEvent('user_interaction', eventArgs)

  },
}, Settings)

function downloadClick(store: string) {
  AppAnalytics.event('download_click', { store, conversion: true })
}

const analyticsEvents = {
  downloadClick,
} as const

export const AnalyticsEvents = {
  ...analyticsEvents,
}
